import { lazy, Suspense } from 'react'
import { Spinner, Center } from '@chakra-ui/react'
import styles from './styles.module.scss'

// Lazy load ReactQuill and its dependencies
const ReactQuill = lazy(async () => {
  const { default: ReactQuill, Quill } = await import('react-quill')
  await import('react-quill/dist/quill.snow.css')
  
  // Configure Quill font options after import
  const Font = Quill.import('formats/font')
  Font.whitelist = ['sansserif', 'serif', 'monospace']
  Quill.register(Font, true)
  
  return { default: ReactQuill }
})

interface IEditorProps {
  value: string
  setValue: (value: string) => void
}

export const Editor = ({ value, setValue, ...props }: IEditorProps) => {
  const formats = [
    'font',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link'
  ]

  const modules = {
    toolbar: [
      [{ font: ['sansserif', 'serif', 'monospace'] }],
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
      ['clean']
    ]
  }

  return (
    <div className={styles.editorContainer}>
      <Suspense fallback={
        <Center height="200px" justifyContent="center" alignItems="center">
            Loading editor...
        </Center>
      }>
        <ReactQuill
          theme="snow"
          className={styles.editor}
          value={value}
          modules={modules}
          formats={formats}
          onChange={setValue}
          placeholder="Enter your welcome message here..."
          {...props}
        />
      </Suspense>
    </div>
  )
}
